import React from 'react';
import PropTypes from 'prop-types';

import IconSearch from 'icons/Search';
import IconClose from 'icons/Close';

import SearchFormWrapper from './SearchFormWrapper';
import InputStyled from './InputStyled';
import OpenButton from './OpenButton';
import CancelButton from './CancelButton';

class SearchForm extends React.Component {
  state = {
    isSearchFormOpen: false,
  };

  componentDidMount() {
    window.addEventListener('keyup', this.handleKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp);
  }

  handleSearchFormClose = () => {
    this.setState({ isSearchFormOpen: false }, this.props.onClose);
  };

  handleSearchFormOpen = () => {
    this.setState({ isSearchFormOpen: true });
  };

  handleKeyUp = (e) => {
    if (e.keyCode !== 27) return; // 27 - код Ecs

    this.setState({ isSearchFormOpen: false });
    this.props.onClose();
  };

  render() {
    return (
      <SearchFormWrapper onSubmit={this.props.onSubmit}>
        <OpenButton
          type="button"
          isSearchFormOpen={this.state.isSearchFormOpen}
          onClick={this.handleSearchFormOpen}
          disabled={this.state.isSearchFormOpen}
        >
          <IconSearch />
        </OpenButton>

        {this.state.isSearchFormOpen && (
          <React.Fragment>
            <InputStyled
              type="text"
              placeholder={this.props.placeholder}
              value={this.props.value}
              onChange={this.props.onChange}
              autoFocus
            />

            <CancelButton type="button" onClick={this.handleSearchFormClose}>
              <IconClose />
            </CancelButton>
          </React.Fragment>
        )}
      </SearchFormWrapper>
    );
  }
}

SearchForm.defaultProps = {
  value: '',
  placeholder: 'Поиск',
  onChange: () => {},
  onSubmit: () => {},
  onClose: () => {},
};

SearchForm.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default SearchForm;
